function encodeVersion ({ major, minor }) {
  return (major << 16) + minor
}

function decodeVersion (version) {
  return { major: (version >> 16) & 0xFFFF, minor: version & 0xFFFF }
}

function decodeVersionString (version) {
  const value = decodeVersion(version)
  return `${value.major}.${value.minor}`
}

export { encodeVersion, decodeVersion, decodeVersionString }



// WEBPACK FOOTER //
// ./src/utils/versionConverter.js